export default __webpack_public_path__ + "static/media/page-thumbnail.46c5ad86.png";